import Rete from "rete";
import { StringSocket,StringControl } from "../rete-controls/StringControl.js"
import ReteComponentStore from "../ReteComponentStore.js"

export default class StringComponent extends Rete.Component {
    constructor(){
        super("String Input"); // name
        this._categories = ["Input Nodes"];
    }

    builder(node) {
        let out1 = new Rete.Output('out1','OUT',StringSocket);
        let numControl = new StringControl(this.editor,"string",false);
      
        return node
        .addOutput(out1)
        .addControl(numControl);
    }

    worker(node, inputs, outputs) {
        outputs['out1'] = node.data;
        //console.log(this.name + " node.data=" + JSON.stringify(node.data));
        //console.log(this.name + " outputs=" + JSON.stringify(outputs));
    }
}
//ReteComponentStore.add(new NumberInputComponent());